<template>
    <div style="display: inline-block;margin-left: 5px;margin-right: 5px;height: 50px;"> 
        <div style="font-size:8px;font-weight:bold">#{{ id }}</div>
        <div :style="{backgroundImage: 'url(' + imgUrl + ')', backgroundRepeat: 'no-repeat', backgroundSize: '100% 100%',height:'20px',width:'40px'}"
        style="line-height: 20px;font-size: 8px;font-weight: bold;">
            {{ text}}
        </div>
    </div>
</template>

<script>
// import { number } from 'echarts';

export default{
    name:'BatteryBalance',
    data(){
        return{
            index:0,
            imgUrl:require('../../assets/0.png'),
            imgList: [require('../../assets/0.png'),
            require('../../assets/1.png'),
            require('../../assets/2.png'),
            require('../../assets/3.png'),
            require('../../assets/4.png')]
            }
        },
    props:{
        text:{
            type:Number,
            required:true,
        },
        id:{
            type:Number,
            required:true,
        },
        status:{
            type:String,
            required:true,
        }

    },
    created(){
        setInterval(this.ChargeStatus,500);
    },
    methods:{
        ChargeStatus(){
            if(this.status=='charge'){
                this.index=this.index+1;
                if(this.index>4){
                    this.index=0
                }
                return;
            }
            if(this.status==='discharge'){
                this.index=this.index-1;
                if(this.index<0){
                    this.index=4
                }
                return;
            }
        }
    },
    watch:{
        index:{
            handler(newVal){
                this.imgUrl=this.imgList[newVal]
            }
        }
    },
    computed: {
        imageUrl: function() {
                return this.imgList[this.index]
        }
    }
}
</script>